import ViewQuiltIcon from '@material-ui/icons/ViewQuilt'
import ChatIcon from '@material-ui/icons/Chat'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import PeopleIcon from '@material-ui/icons/People'
import ShowChartIcon from '@material-ui/icons/ShowChart'
import SettingsIcon from '@material-ui/icons/Settings'
import { PartnersIcon } from '../../admin/v2/partials/AdminMenu'
export const INCLUSIVV_FOR_LINKS = [
  { label: 'nav.companies', url: 'https://www.equitabledinners.com/equitable-dinners-at-work' },
  { label: 'nav.universities', url: 'https://www.equitabledinners.com' },
  { label: 'nav.citiesRegions', url: 'https://www.equitabledinners.com' },
  { label: 'nav.Individuals', url: 'https://www.equitabledinners.com' }
]
export const ABOUT_LINKS = [
  { label: 'nav.blog', url: 'https://www.equitabledinners.com' },
  { label: 'nav.impactStories', url: 'https://www.equitabledinners.com' },
  { label: 'nav.ourStory', url: 'https://www.outofhandtheater.com/equitable-dinners-2' },
  { label: 'nav.ourTeam', url: 'https://www.outofhandtheater.com' },
  { label: 'nav.press', url: 'https://www.outofhandtheater.com' }
]
export const EXPLORE_LINKS = [
  { label: 'nav.overview', url: 'https://www.equitabledinners.com' },
  { label: 'nav.conversationTopics', url: 'https://www.equitabledinners.com' },
  { label: 'nav.conversationSeries', url: 'https://www.equitabledinners.com' },
  { label: 'nav.howToHost', url: 'https://www.equitabledinners.com/how-to-host' }
]
export const MY_ORGANIZATION_LINK = [
  { label: 'nav.dashboard', url: '/admin', icon: ViewQuiltIcon },
  { label: 'nav.topics', url: '/admin/topics', icon: ChatIcon },
  { label: 'nav.conversations', url: '/admin/conversations', icon: CalendarTodayIcon },
  { label: 'nav.attendees', url: '/admin/attendees', icon: PeopleIcon },
  // { label: 'nav.surveys', url: '/admin', icon: 'fal fa-chart-bar' },
  { label: 'nav.stories', url: '/admin/stories', icon: 'far fa-book-spells' },
  { label: 'nav.analytics', url: '/admin/analytics', icon: ShowChartIcon },
  { label: 'nav.partners', url: '/admin/settings', icon: PartnersIcon }
  // { label: 'nav.helpDocumentation', url: 'https://help.inclusivv.co/en/' }
]

export const PRICING_LINKS = 'https://www.equitabledinners.com'
export const TALK_TO_EXPERTS_LINK = 'https://www.equitabledinners.com'
